import { ChevronRight } from '@mui/icons-material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// eslint-disable-next-line no-restricted-imports -- pre-existing EnhancedTable usage; migrate off when touched
import EnhancedTable from '@sophocles/components/EnhancedTable';
import AlarmChipCell from '@sophocles/data-grids/components/cells/AlarmChipCell';
import { loadSites } from '@sophocles/features/sites/api';
import { generateQueryParams } from '@sophocles/utils';
import { severityStatusFamily } from '@sophocles/utils/alarmSeverity';

function ExcessiveAlarmSitesTable(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const table = useRef();

  const getDataFetcher = () => {
    return params =>
      dispatch(
        loadSites(
          generateQueryParams({ ...params, relay_controller__isnull: false, reporting_excessive_alarms: true }),
        ),
      );
  };

  const filters = [];

  const columns = [
    {
      id: 'id',
      label: t('general.id', 'ID'),
      sortable: true,
    },
    {
      id: 'association',
      label: t('general.customer', 'Customer'),
      sortable: false,
      cellRenderer: (datum, row, rowIndex) => {
        return datum.customer?.name ?? '';
      },
    },
    {
      id: 'association',
      label: t('sites.siteGroup', 'Site Group'),
      sortable: false,
      cellRenderer: (datum, row, rowIndex) => {
        return datum.site_group?.name ?? '';
      },
    },
    {
      id: 'name',
      label: t('general.name', 'Name'),
      sortable: true,
    },
    {
      id: 'description',
      label: t('general.description', 'Description'),
      sortable: true,
    },
    {
      id: 'alarm_states',
      label: t('general.alarms', 'Alarms'),
      sortable: false,
      param: 'alarm_states',
      cellRenderer: (datum, row, rowIndex) => {
        return (
          <AlarmChipCell
            alarms={datum.map(alarm => ({
              id: alarm.id,
              label: alarm.display_name,
              color: severityStatusFamily(alarm.severity),
            }))}
          />
        );
      },
    },
  ];

  return (
    <EnhancedTable
      hoverable
      editable
      ref={table}
      title={t('sites.excessiveSiteAlarmsReport', 'Excessive Site Alarms Report')}
      columns={columns}
      filters={filters}
      editIcon={<ChevronRight />}
      fetchData={getDataFetcher()}
      searchFields={['name', 'description', 'id']}
      defaultRowsPerPage={25}
      defaultOrderBy="id"
      defaultOrder="desc"
      onEdit={row => {
        const { customer, site_group } = row.association;
        navigate(`/c/${customer?.id}/plant/${site_group?.id}/structure/${row.id}`);
      }}
      {...props}
    />
  );
}

export default ExcessiveAlarmSitesTable;
